import React, { useState, useEffect } from 'react'

import './IndicatorHistoryPopup.css'
import { store } from '../../stores/store';
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from 'recharts';
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';
import IndHistoryChart from '../IndHistoryChart/IndHistoryChart';


function close() {
  PopupStore.close(POPUPS_IDS.IND_HISTORY)
}




const IndicatorHistoryPopup = ({data}) => {
  let indTitle = data.title

  let title = indTitle
  if(data.unit) title += ` (${data.unit})`

  return (
  <div className="overlay" onClick={close}>
    <div className="IndicatorHistoryPopup">
      <div className="title">
        <span dangerouslySetInnerHTML={{__html: title}} />
        <div className="close-button" onClick={close} />
      </div>
      <div className="content">
        <IndHistoryChart indId={data.id} unit={data.unit} />
      </div>
    </div>
  </div>);
};

export default IndicatorHistoryPopup;
